import { seasonsService } from '@/features/seasons/services/seasons.service'
import type { FilmDocument, SeasonDocument } from '@/types'

export const publicService = {
  getLatestFilm: (): Promise<(FilmDocument & { id: string }) | null> =>
    seasonsService.getLatestFilm(),

  getPublishedSeasons: (): Promise<Array<SeasonDocument & { id: string }>> =>
    seasonsService.getPublishedSeasons(),
}
